import { useEffect, useState } from "react";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./groupStyles.module.scss";
import TabButton from "@Pages/BookForm/components/TabButtonGroup/TabButton";
import useIsDesktop from "hooks/useIsDesktop";

type LabelledRadioButtonGroupProps = {
  options: Record<string, string>;
  value: string;
  error: string;
  showErrorMessage: boolean;
  onSelect: (value: string) => void;
  inputName: string;
  label: string;
  shouldShowVertical?: boolean;
};

const LabelledRadioButtonGroup = ({
  options,
  value,
  error,
  showErrorMessage,
  onSelect,
  label,
  inputName,
  shouldShowVertical = false,
}: LabelledRadioButtonGroupProps) => {
  const [activeTab, setActiveTab] = useState(value);

  const isDesktop = useIsDesktop();
  useEffect(() => {
    setActiveTab(value);
  }, [value]);
  const renderTabs = () =>
    Object.keys(options).map((key, idx) => (
      <TabButton
        index={idx}
        label={options[key]}
        isActive={activeTab === key}
        handleClick={() => {
          setActiveTab(key);
          onSelect(key);
        }}
        inputName={inputName}
        className={styles.tab}
        shouldShowVertical={shouldShowVertical}
      />
    ));
  return (
    <>
      <div className={styles.container}>
        <span className={styles.label}>{label}</span>
        {isDesktop ? renderTabs() : <div className={styles.tabGroup}>{renderTabs()}</div>}
      </div>
      {showErrorMessage && <div className={styles.errorMessage}>{error}</div>}
    </>
  );
};

export default wrapperHOC(LabelledRadioButtonGroup, {
  componentName: "LabelledRadioButtonGroup",
  showForChina: true,
});
